/* Antioxidant Advantage LP — all page behaviour. No Liquid in this file.
 *
 * 1. Checkout — the one checkout button on the page ([data-aalp-checkout]).
 * 2. Expert tabs — S03 ([data-aalp-tabs]).
 * 3. Review videos — S04 ([data-aalp-video] + [data-aalp-vmodal]).
 *
 * The FAQ needs no script: it is native <details>/<summary>.
 */
(function () {
  'use strict';

  /* ------------------------------------------------------------------------
   * 1. CHECKOUT
   *
   * ONE offer, as designed: the 90-day subscription + 3 free Digestive Bitters.
   * Verified against the live store 2026-09-24 (Admin API):
   *   JTPRO90  variant 40805432262721  $129.99, selling plan 844103745
   *            "Every 3 months", fixed −$5.00 → $124.99
   *   JTBTR    variant 42264854691905  $29.99, inventory policy CONTINUE
   *   FREEBITTERS3  ACTIVE, no end date — zeroes the 3 Bitters
   *
   * No shipping code: this cart clears the $99 free-shipping threshold on its own,
   * and a second shipping discount on an already-free order is a bug, not a saving.
   * No pill case: the comp does not include one.
   *
   * Hardcoded on purpose. These are not customizer settings — a typo in a setting
   * breaks checkout silently, which is worse than a code change that shows in a diff.
   *
   * jt-lp-cart.js (already live, shared with the Javvy page) builds the cart
   * permalink, stamps the attribution attributes, pushes the one canonical
   * add_to_cart, and redirects: /cart/clear → /cart/add → /checkout?discount=.
   * ---------------------------------------------------------------------- */
  var OFFER = {
    sub:      { sku: 'JTPRO90', variantId: '40805432262721', planId: '844103745', tier: '90day' },
    bonus:    { sku: 'JTBTR',   variantId: '42264854691905', qty: 3 },
    discount: 'FREEBITTERS3'
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-aalp-checkout]');
    if (!btn) return;
    var cart = window.JT && window.JT.cart;
    if (!cart || !cart.checkoutBundle) {
      // Both scripts are deferred; if a very fast click beats jt-lp-cart.js, say so
      // rather than failing silently on the one button we are paying for.
      console.error('[AALP] jt-lp-cart.js not ready — checkout aborted');
      return;
    }
    btn.setAttribute('aria-busy', 'true');
    cart.checkoutBundle({ sub: OFFER.sub, bonus: OFFER.bonus, discount: OFFER.discount });
  });

  /* ------------------------------------------------------------------------
   * 2. EXPERT TABS (WAI-ARIA tabs pattern: click, ←/→, Home/End)
   * Each expert has two panels sharing an index — the text in the left column and
   * the photo in the right — so both are toggled together.
   * ---------------------------------------------------------------------- */
  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-aalp-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-aalp-panel]'));
    if (!tabs.length) return;

    function select(i, focus) {
      tabs.forEach(function (t, n) {
        var on = n === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      panels.forEach(function (p) {
        p.hidden = String(i) !== p.getAttribute('data-aalp-panel');
      });
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i, false); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = tabs.length - 1;
        if (n !== null) { e.preventDefault(); select(n, true); }
      });
    });
  }

  /* ------------------------------------------------------------------------
   * 3. REVIEW VIDEOS — S04 cards with [data-aalp-video] open one shared <dialog>.
   * Esc and the backdrop close it (native dialog behaviour for Esc; backdrop is a
   * click on the dialog element itself). Closing pauses and unloads the video so
   * audio never keeps playing behind the page.
   * ---------------------------------------------------------------------- */
  function initVideos() {
    var modal = document.querySelector('[data-aalp-vmodal]');
    if (!modal || typeof modal.showModal !== 'function') return;
    var video = modal.querySelector('video');
    var opener = null;

    // Stop and unload the video. Called directly by × / backdrop, and again from the
    // dialog's 'close' event for Esc. The event is dispatched asynchronously (and not
    // at all while the tab is hidden), so the × path must not depend on it or the
    // audio can keep playing. Safe to run twice.
    function unload() {
      if (!video.getAttribute('src')) return;
      video.pause();
      video.removeAttribute('src');
      video.load();
    }
    function close() {
      unload();
      if (modal.open) modal.close();
      if (opener) { opener.focus(); opener = null; }
    }
    modal.addEventListener('close', function () { unload(); if (opener) { opener.focus(); opener = null; } });
    modal.addEventListener('cancel', unload);         // Esc, synchronously
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('[data-aalp-vclose]')) close();
    });
    document.addEventListener('click', function (e) {
      var card = e.target.closest && e.target.closest('[data-aalp-video]');
      if (!card) return;
      opener = card;
      video.poster = card.getAttribute('data-aalp-poster') || '';
      video.src = card.getAttribute('data-aalp-video');
      modal.showModal();
      var p = video.play();
      if (p && p.catch) p.catch(function () { /* autoplay refused: controls are showing */ });
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-aalp-tabs]'), initTabs);
    initVideos();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
